import { render } from "./HomeMenu.vue?vue&type=template&id=4561a3f4&scoped=true"
import script from "./HomeMenu.vue?vue&type=script&lang=js"
export * from "./HomeMenu.vue?vue&type=script&lang=js"

import "./HomeMenu.vue?vue&type=style&index=0&id=4561a3f4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4561a3f4"]])

export default __exports__